<script setup lang="ts">
import { CustomerServiceProps } from "./CustomerService.props"

defineProps<CustomerServiceProps>()
</script>

<template>
  <section
    class="
      banner-help-customer_service
      grid-container
      relative
      px-4
      pb-[60px]
      pt-6
    "
    :class="
      isCheckout
        ? 'flex flex-col overflow-hidden rounded-lg  md:mt-10 md:px-10 md:py-6 lg:px-10'
        : 'md:px-[72px] md:py-16 lg:px-[228px]'
    "
  >
    <UtilsWrapperImage
      v-if="bgImage"
      v-bind="bgImage"
      :key="bgImage.image.url"
      class="
        wrapper-image-full-container-centered
        absolute
        inset-0
        overflow-hidden
      "
      sizes="100vw sm:100vw "
    />
    <div class="text-white z-10 col-span-full md:col-span-3">
      <!-- Caption -->
      <p v-if="caption" class="beaver">
        {{ caption }}
      </p>
      <!-- Title -->
      <p v-if="title" class="md:mammoth-bold elephant-bold py-2 md:pb-5">
        {{ title }}
      </p>
      <!-- Text -->
      <UtilsMarkdown v-if="text" class="beaver md:pig pb-6" :content="text" />
    </div>

    <!-- Cards List -->
    <BannerUtilityCard
      v-for="(card, index) in listHelpCard"
      :key="`helpCard-${index}`"
      class="z-10 col-span-full mb-4 md:col-span-3"
      v-bind="card"
      theme="green"
    />
  </section>
</template>
